import { Directive, ElementRef, Output, EventEmitter, HostListener, Input } from '@angular/core';
var ClickOutsideDirective = /** @class */ (function () {
    function ClickOutsideDirective(_elementRef) {
        this._elementRef = _elementRef;
        this.clickOutside = new EventEmitter();
    }
    ClickOutsideDirective.prototype.onClick = function (event, targetElement) {
        if (!targetElement) {
            return;
        }
        var clickedInside = this._elementRef.nativeElement.contains(targetElement);
        if (!clickedInside) {
            this.clickOutside.emit(event);
        }
    };
    ClickOutsideDirective.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[clickOutside]'
                },] },
    ];
    /** @nocollapse */
    ClickOutsideDirective.ctorParameters = function () { return [
        { type: ElementRef, },
    ]; };
    ClickOutsideDirective.propDecorators = {
        'clickOutside': [{ type: Output },],
        'onClick': [{ type: HostListener, args: ['document:click', ['$event', '$event.target'],] }, { type: HostListener, args: ['document:touchstart', ['$event', '$event.target'],] },],
    };
    return ClickOutsideDirective;
}());
export { ClickOutsideDirective };
var ScrollDirective = /** @class */ (function () {
    function ScrollDirective(_elementRef) {
        this._elementRef = _elementRef;
        this.scroll = new EventEmitter();
    }
    ScrollDirective.prototype.onClick = function (event, targetElement) {
        this.scroll.emit(event);
    };
    ScrollDirective.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[scroll]'
                },] },
    ];
    /** @nocollapse */
    ScrollDirective.ctorParameters = function () { return [
        { type: ElementRef, },
    ]; };
    ScrollDirective.propDecorators = {
        'scroll': [{ type: Output },],
        'onClick': [{ type: HostListener, args: ['scroll', ['$event'],] },],
    };
    return ScrollDirective;
}());
export { ScrollDirective };
// tslint:disable-next-line:class-name
var styleDirective = /** @class */ (function () {
    function styleDirective(el) {
        this.el = el;
    }
    // tslint:disable-next-line:use-life-cycle-interface
    styleDirective.prototype.ngOnInit = function () {
        this.el.nativeElement.style.top = this.styleVal;
    };
    // tslint:disable-next-line:use-life-cycle-interface
    styleDirective.prototype.ngOnChanges = function () {
        this.el.nativeElement.style.top = this.styleVal;
    };
    styleDirective.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[styleProp]'
                },] },
    ];
    /** @nocollapse */
    styleDirective.ctorParameters = function () { return [
        { type: ElementRef, },
    ]; };
    styleDirective.propDecorators = {
        'styleVal': [{ type: Input, args: ['styleProp',] },],
    };
    return styleDirective;
}());
export { styleDirective };
// tslint:disable-next-line:directive-class-suffix
var SetPosition = /** @class */ (function () {
    function SetPosition(el) {
        this.el = el;
    }
    SetPosition.prototype.ngOnInit = function () {
        if (this.height) {
            // tslint:disable-next-line:radix
            this.el.nativeElement.style.bottom = parseInt(this.height + 15 + '') + 'px';
        }
    };
    SetPosition.prototype.ngOnChanges = function () {
        if (this.height) {
            // tslint:disable-next-line:radix
            this.el.nativeElement.style.bottom = parseInt(this.height + 15 + '') + 'px';
        }
    };
    SetPosition.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[setPosition]'
                },] },
    ];
    /** @nocollapse */
    SetPosition.ctorParameters = function () { return [
        { type: ElementRef, },
    ]; };
    SetPosition.propDecorators = {
        'height': [{ type: Input, args: ['setPosition',] },],
    };
    return SetPosition;
}());
export { SetPosition };
//# sourceMappingURL=clickOutside.js.map


//////////////////
// WEBPACK FOOTER
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/node_modules/angular4-multiselect-dropdown/dist/clickOutside.js
// module id = ../../../../angular4-multiselect-dropdown/dist/clickOutside.js
// module chunks = vendor